import React from 'react'
import Footer from '../../../components/Footer'
import ScienceImg from "../../../assets/images/science.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';
const BSCZBC = () => {
    return (
        <div className='  w-full relative font-poppins ' >
            <Title canonicalPath="/programmes/ug-courses/sciences/bsc/chemistry-botany-zoology
" />
            <Title title="B.Sc. in Zoology, Botany, Chemistry at Maya Devi University" description="Enroll in the B.Sc. in Zoology, Botany, and Chemistry program at Maya Devi University, Dehradun. Build a strong foundation for a career in biological sciences." />
            <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
                <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>B.Sc.in Zoology-Botany-Chemistry (ZBC)</h2>
                <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[60px] mt-5 justify-center md:justify-between ' >
                    <img src={ScienceImg} className=' md:w-[40%] rounded-lg ' alt='Student in a bio lab' />
                    <div className=' flex flex-col gap-4 ' >
                        <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
                        <p className=' text-justify md:text-md ' >Bachelor of Science (B.Sc.) in Chemistry, Botany and Zoology (B.Sc. in CBZ) is a regular degree program which deals with the field of science and is designed to emphasize the fundamentals of the basic sciences. The duration of the course is four years which consists of eight semesters under the New Education Policy 2020. It includes 2-year (diploma), 3-year (degree) and 4-year (research / honours) exit options. It comprises both theory and practical components in various aspects of sciences. It aims at providing a solid foundation for the students who would like to pursue higher education or a career in biological or chemical sciences. The curriculum is devised to inculcate research culture and environmental awareness amongst the students.
                            <br /><br />
                            Therefore, all the three subjects in B.Sc. CBZ are combined and taught in detail. Under chemistry, candidates learn about the science of substance in a more precise manner. Students also learn about Botany, which includes study about algae, fungi, ferns, liverworts, gymnosperms, flowering plants and their growth, development, structure, reproduction, metabolism, etc. The Zoology branch of the course deals with topics like the animal kingdom, their classification, evolution, embryology, structure, etc. for both living and extinct animals. The course delivery methods include classroom lectures, discussions, presentations, seminars, and educational visits. Students are also involved in in-house projects gaining exposure in the research field. Consequently, along with the underlying hypothetical understanding, the students are exposed to realistic aspects through the sparkling laboratory sessions.</p>
                        <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link>
                    </div>
                </div>

                <div className=' flex flex-col gap-10 mt-5 mb-[20px] ' >
                    <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>Intermediate / 10+2 or its equivalent examination with PCB (Physics, Chemistry, Biology) from a recognized Board/ University/ MDU Entrance Examination</p>
                    </div>
                </div>

                <h4 className={` text-2xl font-semibold text-[#23376c] `}>B.Sc. –(HONORS AND RESEARCH) IN CHEMISTRY</h4>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <ul className=' list-disc ' >
                        <li>Develop research-based knowledge.</li>
                        <li>Employ critical thinking and scientific knowledge to design, carry out, record, and analyze the results of chemical reactions.</li>
                        <li>Create an awareness of the impact of chemistry on the environment, society, and development outside the scientific community.</li>
                        <li>Find out the green route for chemical reaction for sustainable development.</li>
                        <li>Inculcate the scientific temperament in the students and outside the scientific community.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <ul className=' list-disc ' >
                        <li>After BSc in chemistry one can enter multiple domains like in academic or industrial research laboratories, where they conduct experiments, analyze data, develop new compounds or materials, and contribute to scientific discoveries. Chemistry graduates can also work in government agencies, environmental consulting firms, or research organizations, conducting research, analyzing samples, and developing strategies for environmental preservation and remediation.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <ul className=' list-disc ' >
                        <li>Chemical Industries</li>
                        <li>Analytical Chemist</li>
                        <li>Pharmaceutical and Biotechnology Industry</li>
                        <li>Environmental Science</li>
                        <li>Education</li>
                        <li>Forensic Science</li>
                        <li>Materials Science</li>
                        <li>Scientific Journalism and Technical Writing</li>
                    </ul>
                </div>

                <h4 className={` text-2xl font-semibold text-[#23376c] mt-[20px] `}>B.Sc. BOTANY (Hons. / Research)</h4>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <ul className=' list-disc ' >
                        <li>To acquire the practical application of basic and conceptualized knowledge of plant sciences.</li>
                        <li>To develop the ability to perform efficiently the various laboratory and field techniques they can apply for scientific reasoning and problem-solving.</li>
                        <li>To develop better communication skills by means of seminar presentations that will help to develop confidence for self-education and ability to engage in life-long learning.</li>
                        <li>To pursue various academic and professional courses and will be ready for entry-level jobs in any area of biology.</li>
                        <li>To facilitate students to take up a successful career in Botany, actively participate, and succeed in various competitive examinations.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <ul className=' list-disc ' >
                        <li>Graduates with a B.Sc. in Botany can pursue various career paths. These include roles in research institutions, botanical gardens, environmental organizations, agricultural firms, conservation agencies, education, and more. Additionally, some students opt for advanced degrees (M.Sc. or Ph.D.) for specialized research or teaching positions.</li>
                        <li>Students develop professional laboratory skills required to work in the sector through practical exposure in the labs. The teaching also focuses on developing the proficiency of problem solving, team working, presentation and communication skills.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <ul className=' list-disc ' >
                        <li>Environment research</li>
                        <li>Agricultural research</li>
                        <li>Forensic research</li>
                        <li>Biochemist</li>
                        <li>Food Scientist and Nutritionist</li>
                        <li>Pharmacist</li>
                        <li>Teacher</li>
                        <li>Technical writer</li>
                        <li>Data Scientist</li>
                        <li>Research Analyst</li>
                        <li>Field investigator</li>
                        <li>Lab Technician</li>
                        <li>Entrepreneur</li>
                    </ul>
                </div>

                <h4 className={` text-2xl font-semibold text-[#23376c] mt-[20px] `}>B.Sc. Zoology (Hons. / Research)</h4>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <ul className=' list-disc ' >
                        <li>Students gain knowledge and skills in the fundamentals of animal sciences and understand the complex interactions among various organisms.</li>
                        <li>Analyse complex interactions among the various animals of different phyla, their distribution, and their relationship with the environment.</li>
                        <li>Educate students to be responsible and productive science students.</li>
                        <li>Develop the skills and knowledge to effectively apply emerging technologies to meet future challenges.</li>
                        <li>Make students ready for a positive contribution to their community and society.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <ul className=' list-disc ' >
                        <li>BSc graduates with zoology can work with organizations like Zoological Survey of India, wild life or work in areas such as poultry farming, sericulture, or pisciculture. Along with these fields, teaching, government exams, and research are also some viable options. They can even work in biotechnology field and pharmaceutical industries.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <ul className=' list-disc ' >
                        <li>Research assistant</li>
                        <li>Entomologist</li>
                        <li>Conservation Officer</li>
                        <li>Wildlife Technician</li>
                        <li>Environmental Consultant</li>
                        <li>Ecologist</li>
                        <li>Animal nutritionist</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 mt-[20px] mb-[30px] ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>USPs</h4>
                    <ul className=' list-disc ' >
                        <li>Amalgamation of experienced faculty and enriching teaching methodologies.</li>
                        <li>Centre of Excellence in Specific Domain & Technology for Experiential Learning</li>
                        <li>360° Advance Course Curriculum designed by Core Academia & Renowned Industry Experts</li>
                        <li>Live Industry Projects based Learning throughout the course</li>
                        <li>LMS based Pedagogy and Innovative Classroom Teaching Methodology</li>
                        <li>One-to-One Progress Monitoring & Mentoring Methodology throughout the course</li>
                        <li>Choice Based Credit System (CBCS) Based Assessments and Evaluation</li>
                        <li>Full-Time Industrial Internship after 3rd</li>
                        <li>Advance Diagnostic & Mentoring for Career and Placement throughout the Course</li>
                        <li>Dynamic Programming & Core Skill Guidance throughout the course</li>
                        <li>Start-up & Idea Innovation Lab for Career & Professional Growth</li>
                    </ul>
                </div>

                {/* table */}
                <div className="flex flex-col mb-[100px] ">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead
                                        className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                                        <tr>
                                            <th scope="col" className=" px-6 py-4">Programme</th>
                                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Science</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Bachelor of Science (B.Sc.) in <br /> Chemistry, Botany and Zoology (B.Sc. in ZBC)</td>
                                            <td className="whitespace-nowrap  px-6 py-4">3</td>
                                            <td className="whitespace-nowrap  px-6 py-4">25</td>
                                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default BSCZBC